<div
  class="border-line-default focus-within:border-line-brand-bold flex w-full rounded-lg border focus-within:border-2 h-9"
  [class]="styleClass"
  [ngClass]="{ 'border-line-error': error }">
  <ng-content select="[template=prefix]" />
  <p-inputNumber
    class="w-full h-full !focus:border-0 !focus:outline-0"
    styleClass="bg-transparent w-full text-left text-text-subtle text-sm !focus:shadow-0"
    locale="id"
    mode="decimal"
    [useGrouping]="useGrouping"
    [pAutoFocus]="autofocus"
    [placeholder]="placeholder"
    [min]="min"
    [max]="max"
    [maxlength]="maxlength"
    [autofocus]="autofocus"
    [minFractionDigits]="0"
    [maxFractionDigits]="2"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="writeValue($event)" />
  <ng-content select="[template=suffix]" />
  <!-- @if (enterable) {
    <div class="p-1.5">
      <div class="bg-elevation-surface-drop-default flex items-center gap-1 rounded p-0.5 px-1">
        <p class="text-2xs text-text-subtler">Enter</p>
        <ic-enter-left-outline class="text-icon-default block h-3 w-3" />
      </div>
    </div>
  } -->
</div>
